// The parts of LiveKit's signaling protocol (livekit_rtc.proto / livekit_models.proto) that LiveKitConnection
// uses: message name -> { field: [ number, type, repeated ] }. Field numbers must match the server's.

export const SignalTarget = { PUBLISHER: 0, SUBSCRIBER: 1 };
export const TrackType = { AUDIO: 0, VIDEO: 1 };
export const TrackSource = { CAMERA: 1, MICROPHONE: 2, SCREEN_SHARE: 3, SCREEN_SHARE_AUDIO: 4 };
export const ParticipantState = { JOINING: 0, JOINED: 1, ACTIVE: 2, DISCONNECTED: 3 };
export const DisconnectReason = { CLIENT_INITIATED: 1 };

export default {
	SignalRequest: {
		offer: [ 1, 'SessionDescription' ],
		answer: [ 2, 'SessionDescription' ],
		trickle: [ 3, 'TrickleRequest' ],
		add_track: [ 4, 'AddTrackRequest' ],
		subscription: [ 6, 'UpdateSubscription' ],
		leave: [ 8, 'LeaveRequest' ],
		ping: [ 14, 'int64' ],
	},
	SignalResponse: {
		join: [ 1, 'JoinResponse' ],
		answer: [ 2, 'SessionDescription' ],
		offer: [ 3, 'SessionDescription' ],
		trickle: [ 4, 'TrickleRequest' ],
		update: [ 5, 'ParticipantUpdate' ],
		track_published: [ 6, 'TrackPublishedResponse' ],
		leave: [ 8, 'LeaveRequest' ],
		pong: [ 18, 'int64' ],
		request_response: [ 22, 'RequestResponse' ],
	},
	SessionDescription: {
		type: [ 1, 'string' ],
		sdp: [ 2, 'string' ],
		id: [ 3, 'uint32' ],
	},
	TrickleRequest: {
		candidateInit: [ 1, 'string' ],
		target: [ 2, 'enum' ],
		final: [ 3, 'bool' ],
	},
	AddTrackRequest: {
		cid: [ 1, 'string' ],
		name: [ 2, 'string' ],
		type: [ 3, 'enum' ],
		width: [ 4, 'uint32' ],
		height: [ 5, 'uint32' ],
		muted: [ 6, 'bool' ],
		source: [ 8, 'enum' ],
		stream: [ 15, 'string' ],
	},
	UpdateSubscription: {
		track_sids: [ 1, 'string', true ],
		subscribe: [ 2, 'bool' ],
		participant_tracks: [ 3, 'ParticipantTracks', true ],
	},
	ParticipantTracks: {
		participant_sid: [ 1, 'string' ],
		track_sids: [ 2, 'string', true ],
	},
	LeaveRequest: {
		can_reconnect: [ 1, 'bool' ],
		reason: [ 2, 'enum' ],
		action: [ 3, 'enum' ],
	},
	JoinResponse: {
		participant: [ 2, 'ParticipantInfo' ],
		other_participants: [ 3, 'ParticipantInfo', true ],
		ice_servers: [ 5, 'ICEServer', true ],
		subscriber_primary: [ 6, 'bool' ],
		ping_timeout: [ 10, 'int32' ],
		ping_interval: [ 11, 'int32' ],
	},
	ParticipantInfo: {
		sid: [ 1, 'string' ],
		identity: [ 2, 'string' ],
		state: [ 3, 'enum' ],
		tracks: [ 4, 'TrackInfo', true ],
		name: [ 9, 'string' ],
	},
	TrackInfo: {
		sid: [ 1, 'string' ],
		type: [ 2, 'enum' ],
		name: [ 3, 'string' ],
		muted: [ 4, 'bool' ],
		source: [ 9, 'enum' ],
		mid: [ 12, 'string' ],
	},
	ICEServer: {
		urls: [ 1, 'string', true ],
		username: [ 2, 'string' ],
		credential: [ 3, 'string' ],
	},
	ParticipantUpdate: {
		participants: [ 1, 'ParticipantInfo', true ],
	},
	TrackPublishedResponse: {
		cid: [ 1, 'string' ],
		track: [ 2, 'TrackInfo' ],
	},
	RequestResponse: {
		request_id: [ 1, 'uint32' ],
		reason: [ 2, 'enum' ],
		message: [ 3, 'string' ],
	},
};
